<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-exp-and-auto-header">
    <div class="top-flex">
      <div :class="(panelHeaderData && panelHeaderData.tooltips && panelHeaderData.data.length > 0? 'left' : 'no-data-panel-type-container')">
        <div class="panel-title">{{panelTitle}}</div>
        <!-- <el-tooltip v-if="!controller.loading && panelHeaderData.tooltips && panelHeaderData.data.length > 0" popper-class="header-info-poppers" class="item" effect="dark" placement="bottom">
          <div slot="content"><span v-html="panelHeaderData.tooltips"></span></div>
          <div class="icon-info"></div>
        </el-tooltip>
        
        <div v-else ></div> -->
        <span v-if="controller.controller.selection!='all'" :class="(panelHeaderData.tooltips && panelHeaderData.data.length > 0? 'panel-type' : 'no-data-panel-type')">({{displaySection(controller.controller.selection)}})</span>
      </div>
      <div class="flex-container">
        <!-- <wy-exp-and-auto-header-popup :selecteddatePeriodRange="selecteddatePeriodRange" :graphType="graphType" :panelTitleNoBracket="panelTitleNoBracket" :panelTitle=panelTitle :showChartViewBy=showChartViewBy v-show="panelHeaderData.label" ref="settingSection" :controller="controller" /> -->
      </div>
      
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';

  export default Vue.extend({
    name: 'wy-exp-and-auto-header',
    props: ["selecteddatePeriodRange","controller", "panelHeaderData", "panelTitle", "showChartViewBy", "panelTitleNoBracket", "graphType"],

    methods: {
      displaySection(section) {
        if(section == 'contained') {
          return 'Intents to contain';
        }
        if(section == 'handoff') {
          return 'Intents to handoff';
        }
        return ''
      }
    }

  });
</script>

<style lang="scss">

  .wy-exp-and-auto-header {
    background-color: #FFF;
    // height: 63px;

    .flex-container {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
    }

    .top-flex{
      display: flex;
      padding: 15px;
      background-color: #FFF;
      padding-bottom: 4px;
      border-bottom: 1px solid #CAD2DA;
      font-size: 18px;
      justify-content: space-between;
      margin-top: 3px;
      height: 42px;
    }
    .bottom-left-stats-small-flex{
      display: flex;
      margin-top: 15px;
      align-items: center;
    }
    .icon-info{
      display: inline-block;
      background: url('../../assets/icons/icon_info_performance_overview.svg') no-repeat;
      width: 20px;
      height: 17px;
      position: relative;
      top: 8px;
      margin-left: 0.25vw;
    }
    .panel-title {
      // font-size: 1.2vw;
      font-size: 18px;
      font-family: Helvetica Neue, Helvetica;
      font-weight: 500;
      color: var(--site-font-secondary-color);
      display: inline-block;
      position: relative;
      top: 4px;
    }
    span.panel-type {
      // padding: 8px;
      font-size: 18px;
      position: relative;
      top: 4px;
    }
    .no-data-panel-type-container{
      display: flex;
      align-items: center;
      margin-bottom: 16px;
    }
    .no-data-panel-type{
      font-size: 18px;
      position: relative;
      top: 4px;
      margin-left: 10px;
    }

    .el-input--mini .el-input__inner {
      height: 31px;
      width: 4.8vw;
      line-height: 1.34vw;
    }
    .setting-arrow-down{
      display: none;
    }
    .el-button.is-plain:hover, .el-button.is-plain:active {
      background: #FFF;
      border: none; 
      color: var(--site-font-tertiary-color);
    }
    .el-button {
      font-family: "Helvetica Neue", Helvetica !important;
      border: none !important;
      font-size: 14.22px;
      color: var(--site-font-tertiary-color);
      font-weight: normal;
      margin-right: 0.5vw;
    }
    img.el-tooltip.move-info {
      width: 30px;
      position: relative;
      cursor: move;
      bottom: 6px;
    }
    .el-dropdown {
      margin-right: 15px;
    }
    .wy-exp-and-auto-header-popup.right {
      display: flex;
      display: none;
      // visibility: hidden;
    }
    .wy-exp-and-auto-header-popup.right.show {
      display: flex !important;
      // visibility: visible;
    }
    button.el-button.gear-dropdowns.el-button--default.is-plain.el-dropdown-selfdefine{
      border: none !important;
    }
    .customer-compare-group-by{
      margin-left: 75px;
    }
  }

  .header-info-poppers{
    font-family: Helvetica Neue, Helvetica;
    font-size: 14px;
  }

</style>
